import { Suspense, Fragment } from "react";
import { extractSearchFilesV2 } from "../../helpers/extract";
import { API, graphqlOperation } from "aws-amplify";
import { searchFiles } from "../../graphql/queries";
import SearchBar from "../../components/SearchBar";
import wrapPromise from "../../helpers/wrapPromise";
import RecentlyUpdatedContext from "../../contexts/RecentlyUpdatedContext";
import Waiting from "../../components/Waiting";
import Carousel from "../../components/Carousel";
import Footer from "../../components/Footer";

import { catalogBrandOptions } from "../../constants/enum";
import { group } from "../../constants/enum";

function Home() {
  const fetchRecentlyUpdatedData = () => {
    const recentlyUpdatedFiles: any = API.graphql(
      graphqlOperation(searchFiles, {
        sort: "recent",
        limit: 10,
        from: 0,
      })
    );

    return {
      result: wrapPromise(recentlyUpdatedFiles),
    };
  };

  const ru = fetchRecentlyUpdatedData();

  const data = catalogBrandOptions.reduce((result: any, currentValue: any) => {
    (result[currentValue["groupName"]] =
      result[currentValue["groupName"]] || []).push(currentValue);
    return result;
  }, {});

  const groupData = Object.values(data);

  const RecentlyUpdated = ({ ru }: any) => {
    if (!ru) {
      return <></>;
    }

    const recentlyUpdatedFiles = ru.result.read();
    const files = extractSearchFilesV2(recentlyUpdatedFiles);

    if (files.length === 0) {
      return <div></div>;
    }

    return (
      <RecentlyUpdatedContext.Provider value={{ recentlyUpdated: files }}>
        <div className="w-full">
          <Carousel data={files} />
        </div>
      </RecentlyUpdatedContext.Provider>
    );
  };

  return (
    <>
      <div className="h-screen overflow-auto">
        <div className="flex flex-row justify-center">
          <div className="w-full px-2 pt-4 lg:w-3/4">
            <SearchBar />
          </div>
        </div>
        {/* <div className="m-1">
          <div className="flex flex-row justify-center">
            <div className="w-full px-2 lg:w-3/4">
              <div className="grid grid-cols-4 gap-2 w-9/10">
                {catalogBrandOptions.map((op: any) => {
                  return (
                    <div key={`brand-${op.value.code}`} className="my-1">
                      <div className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700 w-full">
                        <div className="flex flex-row justify-center">
                          <a href={`/catalogue?brand=${op.value.code}`}>
                            <img
                              className="rounded-t-lg"
                              src={`/brands/${op.value.image}`}
                              alt={op.value.name}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div> */}

        <div>
          {groupData.map((p: any, index: number) => {
            const groupStyle: string =
              group[p[0].groupName as keyof typeof group].style;
            return (
              <Fragment key={`group-${index}`}>
                <div className={`flex flex-row gap-2 ${groupStyle}`}>
                  {p.map((op: any) => {
                    return (
                      <div key={`brand-${op.value.code}`} className="my-1">
                        <div className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700 w-full">
                          <div className="flex flex-row justify-center">
                            <a href={`/catalogue?brand=${op.value.code}`}>
                              <img
                                className="rounded-t-lg"
                                src={`/brands/${op.value.image}`}
                                alt={op.value.name}
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Fragment>
            );
          })}
        </div>

        <div className="flex flex-row w-full">
          <Suspense fallback={<Waiting />}>
            <RecentlyUpdated ru={ru} />
          </Suspense>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Home;
